import update from 'react-addons-update'
import fromPairs from 'lodash/fromPairs'

const entities = [
  'areaActivities',
  'areaHistories',
  'areas',
  'areaTypes',
  'comments',
  'contracts',
  'device',
  'locations',
  'inspections',
  'inspectors',
  'issues',
  'issueDescriptions',
  'issueHistories',
  'messages',
  'msdsSheets',
  'pinHistories',
  'pins',
  'services',
  'serviceSummaries',
  'servicings',
  'servicingLabels',
  'subLocations',
  'technicians',
  'users',
  'workOrders',
  'qaServicings',
  'qaTasks',
  'qaWorkOrders',
  'reports',
  'workAreaSummaries',
  'workSummaries',
  'workTrackers',
  'technicianWorkSummaries'
]

export default (state = {}, action) => {
  entities.forEach((entityName) => {
    state = {
      ...state,
      [entityName]: updatedEntitySlice(state, entityName, action)
    }
  })

  return state
}

export const stubbedEntityReducers = fromPairs(
  entities.map((entityName) => [ entityName, (state = {}, action) => state ])
)

function updatedEntitySlice (state, entityName, action = {}) {
  if (action.payload && action.payload.entities && action.payload.entities[entityName]) {
    const slice = action.payload.entities[entityName]

    Object.keys(slice).forEach(entityId => {
      var command = '$set'

      if (state[entityName][entityId]) {
        command = '$merge'
      }

      state = update(
        state,
        {
          [entityName]: {
            [entityId]: {
              [command]: slice[entityId]
            }
          }
        }
      )
    })
  }

  return state[entityName]
}



// WEBPACK FOOTER //
// ./src/reducers/entities-reducer.js